var e = ((t) => (t[t.Left = 0] = "Left", t[t.Right = 2] = "Right", t))(e || {});
export {
  e as MouseButton
};
